import { render, staticRenderFns } from "./CardFee.vue?vue&type=template&id=da0b96ee&scoped=true&"
import script from "./CardFee.vue?vue&type=script&lang=js&"
export * from "./CardFee.vue?vue&type=script&lang=js&"
import style0 from "./CardFee.vue?vue&type=style&index=0&id=da0b96ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0b96ee",
  null
  
)

export default component.exports